<template>
	<div>
		<b-alert :show="!!error" variant="danger">{{error?.error||error}}</b-alert>
		<b-card class="mb-3 text-center">
			<router-link to="/widgets/voices?lang=en"><b-icon icon="soundwave"></b-icon>TTS Voices</router-link>
			&bull;
			<router-link to="/widgets/replacements"><b-icon icon="file-earmark-font-fill"></b-icon> Word replacements</router-link>
			&bull;
			<router-link to="/widgets/event-media"><b-icon icon="music-note-beamed"></b-icon> Alert sounds</router-link>
			&bull;
			<router-link to="/widgets/dono-media"><b-icon icon="piggy-bank-fill"></b-icon> Platform alert sounds</router-link>
			&bull;
			<router-link to="/widgets/tower-detector"><b-icon icon="sort-alpha-down"></b-icon> Tower detector</router-link>
		</b-card>
		<b-form-row>
			<b-col cols="12" lg="6">
				<b-card class="mb-3">
					<template #header>
						Chat widget <b-spinner v-show="chatWidgetLoading > 0" label="Loading" class="ml-2 spinner-border-xs"></b-spinner>
					</template>
					<b-form-row>
						<b-col>
							<b-form-checkbox switch v-model="enableTTS" @change="saveWidgetSettingsField('chat', 'enableTTS', enableTTS, 'TTS')">TTS</b-form-checkbox>
							<b-form-checkbox switch v-model="enableEventSounds" @change="saveWidgetSettingsField('chat', 'enableEventSounds', enableEventSounds, 'Event sounds')">Sounds</b-form-checkbox>
						</b-col>
						<b-col class="text-right" cols="8">
							<a :href="`/widget/chat.html?hash=${encodeURIComponent(user.widget_hash)}`" target="_blank" title="Open chat widget"><b-icon icon="arrow-up-right-square-fill"></b-icon> Open</a>
							&bull;
							<a @click.prevent="copyAndToast(`${$baseUrl}/widget/chat.html?hash=${user.widget_hash}`, 'Copied chat widget URL to clipboard')" href="#"><b-icon icon="clipboard"></b-icon> Copy</a>
							&bull;
							<router-link to="/widgets/chat"><b-icon icon="gear"></b-icon> Settings</router-link>
						</b-col>
					</b-form-row>
				</b-card>
				<b-card header="Viewer count widget" class="mb-3">
					<div class="float-right">
						<a :href="`/widget/viewerCount.html?hash=${user.widget_hash}`" target="_blank" title="Open viewer count widget"><b-icon icon="arrow-up-right-square-fill"></b-icon> Open</a>
						&bull;
						<a @click.prevent="copyAndToast(`${$baseUrl}/widget/viewerCount.html?hash=${user.widget_hash}`, 'Copied viewer count widget URL to clipboard')" href="#"><b-icon icon="clipboard"></b-icon> Copy</a>
						&bull;
						<router-link to="/widgets/viewer-count"><b-icon icon="gear"></b-icon> Settings</router-link>
					</div>
				</b-card>
				<b-card header="Highlighted message widget" class="mb-3">
					<div class="float-right">
						<a :href="`/widget/highlightedMessage.html?hash=${user.widget_hash}`" target="_blank" title="Open highlighted message widget"><b-icon icon="arrow-up-right-square-fill"></b-icon> Open</a>
						&bull;
						<a @click.prevent="copyAndToast(`${$baseUrl}/widget/highlightedMessage.html?hash=${user.widget_hash}`, 'Copied highlighted message widget URL to clipboard')" href="#"><b-icon icon="clipboard"></b-icon> Copy</a>
						&bull;
						<router-link to="/widgets/highlighted-message"><b-icon icon="gear"></b-icon> Settings</router-link>
					</div>
				</b-card>
				<b-card header="Word cloud" class="mb-3">
					<div class="float-right">
						<a :href="`/widget/wordCloud.html?hash=${user.widget_hash}`" target="_blank" title="Open word cloud widget"><b-icon icon="arrow-up-right-square-fill"></b-icon> Open</a>
						&bull;
						<a @click.prevent="copyAndToast(`${$baseUrl}/widget/wordCloud.html?hash=${user.widget_hash}`, 'Copied word cloud widget URL to clipboard')" href="#"><b-icon icon="clipboard"></b-icon> Copy</a>
						&bull;
						<span class="text-secondary"><b-icon icon="gear"></b-icon> Settings</span>
					</div>
				</b-card>
			</b-col>
			<b-col cols="12" lg="6">
				<b-card class="mb-3">
					<template #header>
						Alert widget <b-spinner v-show="giftWidgetLoading > 0" label="Loading" class="ml-2 spinner-border-xs"></b-spinner>
					</template>
					<b-form-row>
						<b-col>
							<b-form-checkbox switch v-model="enableGiftTTS" @change="saveWidgetSettingsField('gift', 'enableTTS', enableGiftTTS, 'TTS')">TTS</b-form-checkbox>
							<b-form-checkbox switch v-model="enableGiftEventSounds" @change="saveWidgetSettingsField('gift', 'enableEventSounds', enableGiftEventSounds, 'Event sounds')">Sounds</b-form-checkbox>
							<b-form-checkbox switch v-model="enableGiftMedia" @change="saveWidgetSettingsField('gift', 'enableMedia', enableGiftMedia, 'Event media')">Media</b-form-checkbox>
						</b-col>
						<b-col class="text-right" cols="8">
							<a :href="`/widget/gift.html?hash=${user.widget_hash}`" target="_blank" title="Open gift widget"><b-icon icon="arrow-up-right-square-fill"></b-icon> Open</a>
							&bull;
							<a @click.prevent="copyAndToast(`${$baseUrl}/widget/gift.html?hash=${user.widget_hash}`, 'Copied gift widget URL to clipboard')" href="#"><b-icon icon="clipboard"></b-icon> Copy</a>
							&bull;
							<router-link to="/widgets/gift"><b-icon icon="gear"></b-icon> Settings</router-link>
						</b-col>
					</b-form-row>
				</b-card>
				<b-card header="Gift Goal widget" class="mb-3">
					<template #header>
						Gift goal widget <b-spinner v-show="giftGoalWidgetLoading > 0" label="Loading" class="ml-2 spinner-border-xs"></b-spinner>
					</template>
					<b-form-row class="mb-3">
						<b-col>
							<form @submit.prevent.stop="saveWidgetSettingsField('gift-goal', 'goal', parseFloat(giftGoalGoal||0)||0, 'Goal')">
								<b-input-group prepend="Goal" class="mt-1" size="sm">
									<b-form-input type="number" v-model.number="giftGoalGoal" min="0" step="any"></b-form-input>
									<b-input-group-append>
										<b-input-group-text>{{user.currency_code}}</b-input-group-text>
										<b-button type="submit" variant="primary">Set</b-button>
									</b-input-group-append>
								</b-input-group>
							</form>
						</b-col>
						<b-col class="text-right">
							<a :href="`/widget/giftGoal.html?hash=${user.widget_hash}`" target="_blank" title="Open gift goal widget"><b-icon icon="arrow-up-right-square-fill"></b-icon> Open</a>
							&bull;
							<a @click.prevent="copyAndToast(`${$baseUrl}/widget/giftGoal.html?hash=${user.widget_hash}`, 'Copied gift goal widget URL to clipboard')" href="#"><b-icon icon="clipboard"></b-icon> Copy</a>
							&bull;
							<router-link to="/widgets/gift-goal"><b-icon icon="gear"></b-icon> Settings</router-link>
						</b-col>
					</b-form-row>
					<b-form-row>
						<b-col>
							<form @submit.prevent.stop="saveWidgetSettingsField('gift-goal', 'amount', parseFloat(giftGoalAmount||0)||0, 'Amount')">
								<b-input-group prepend="Amount" class="mt-1" size="sm">
									<b-form-input type="number" no-wheel v-model.number="giftGoalAmount" min="0" step="any"></b-form-input>
									<b-input-group-append>
										<b-input-group-text>{{user.currency_code}}</b-input-group-text>
										<b-button type="submit" variant="primary">Set</b-button>
									</b-input-group-append>
								</b-input-group>
							</form>
						</b-col>
						<b-col cols="3">
							<form @submit.prevent.stop="saveWidgetSettingsField('gift-goal', 'amount', parseFloat(giftGoalAmountAdd||0)||0, 'Amount', true); giftGoalAmountAdd = ''">
								<b-input-group class="mt-1" size="sm">
									<b-form-input type="number" v-model.number="giftGoalAmountAdd" step="any"></b-form-input>
									<b-input-group-append>
										<b-button type="submit" variant="secondary" :disabled="!giftGoalAmountAdd">Add</b-button>
									</b-input-group-append>
								</b-input-group>
							</form>
						</b-col>
					</b-form-row>
				</b-card>
				<b-card header="Emote wall" class="mb-3">
					<div class="float-right">
						<a :href="`/widget/emoteWall.html?hash=${user.widget_hash}`" target="_blank" title="Open word cloud widget"><b-icon icon="arrow-up-right-square-fill"></b-icon> Open</a>
						&bull;
						<a @click.prevent="copyAndToast(`${$baseUrl}/widget/emoteWall.html?hash=${user.widget_hash}`, 'Copied word cloud widget URL to clipboard')" href="#"><b-icon icon="clipboard"></b-icon> Copy</a>
						&bull;
						<router-link to="/widgets/emote-wall"><b-icon icon="gear"></b-icon> Settings</router-link>
					</div>
				</b-card>
			</b-col>
		</b-form-row>
	</div>
</template>

<script>
export default {
	data() { return {
		error: null,
		user: {},
		chatWidgetLoading: 0,
		giftWidgetLoading: 0,
		giftGoalWidgetLoading: 0,
		enableTTS: false,
		enableEventSounds: false,
		enableGiftTTS: false,
		enableGiftEventSounds: false,
		enableGiftMedia: false,
		giftGoalAmount: 0,
		giftGoalAmountAdd: 0,
		giftGoalGoal: 0,
	}},
	async mounted() {
		try {
			this.error = null;
			this.loading++;
			await this.loadUserData();
			await this.loadChatWidgetSettings();
			await this.loadGiftWidgetSettings();
			await this.loadGiftGoalWidgetSettings();

			this.subId = this.$socket.subscribe(this.user.widget_hash, {
				userChanged: () => this.loadUserData(),
				widgetSettingsFieldChange: msg => {
					if(msg.widgetType != 'gift-goal') return;
					if(msg.field == 'amount') this.giftGoalAmount = msg.value;
					if(msg.field == 'goal') this.giftGoalGoal = msg.value;
				},
			});
		} catch(e) {
			console.error(e);
			this.error = e;
		} finally {
			this.loading--;
		}
	},
	async beforeDestroy() {
		this.subId && this.$socket.unsubscribe(this.subId);
	},
	methods: {
		async loadUserData() {
			this.user = await this.$api.get('userData');
		},

		async reloadUserData() {
			try {
				this.error = null;
				this.loading++;
				await this.loadUserData();
			} catch(e) {
				console.error(e);
				this.error = e;
			} finally {
				this.loading--;
			}
		},

		async loadChatWidgetSettings() {
			const settings = await this.$api.get('widgetSettings/chat');
			this.enableTTS = settings?.enableTTS||false;
			this.enableEventSounds = settings?.enableEventSounds||false;
		},

		async loadGiftWidgetSettings() {
			const settings = await this.$api.get('widgetSettings/gift');
			this.enableGiftTTS = settings?.enableTTS||false;
			this.enableGiftEventSounds = settings?.enableEventSounds||false;
			this.enableGiftMedia = settings?.enableMedia||false;
		},

		async loadGiftGoalWidgetSettings() {
			const settings = await this.$api.get('widgetSettings/gift-goal');
			this.giftGoalAmount = settings?.amount||0;
			this.giftGoalGoal = settings?.goal||0;
		},

		async reloadChatWidgetSettings() {
			try {
				this.loading++;
				this.error = null
				await this.loadChatWidgetSettings();
			} catch(e) {
				this.error = e;
			} finally {
				this.loading--;
			}
		},

		async reloadGiftWidgetSettings() {
			try {
				this.loading++;
				this.error = null
				await this.loadGiftWidgetSettings();
			} catch(e) {
				this.error = e;
			} finally {
				this.loading--;
			}
		},

		async reloadGiftGoalWidgetSettings() {
			try {
				this.loading++;
				this.error = null
				await this.loadGiftGoalWidgetSettings();
			} catch(e) {
				this.error = e;
			} finally {
				this.loading--;
			}
		},

		saveWidgetSettingsField(type, field, value, name, add) {
			if(type == 'gift')
				this.giftWidgetLoading++;
			else if(type == 'gift-goal')
				this.giftGoalWidgetLoading++;
			else
				this.chatWidgetLoading++;
			this.error = null;
			this.$api.post(`widgetSettings/${encodeURIComponent(type)}/${encodeURIComponent(field)}`, { value, add }).then(() => {
				this.$bvToast.toast(`${name||field} ${value === true ? 'enabled' : (value === false ? 'disabled' : 'updated')}`, { title: 'Success', variant: 'success', solid: true });
			}).catch(err => {
				this.$bvToast.toast(`Could not ${value === true ? 'enable' : (value === false ? 'disable' : 'update')} ${name||field}: ${err.error||err.toString()}`, { title: 'Error', variant: 'danger', solid: true });
			}).finally(() => {
				if(type == 'gift')
					this.giftWidgetLoading--;
				else if(type == 'gift-goal') {
					if(add) this.reloadGiftGoalWidgetSettings();
					this.giftGoalWidgetLoading--;
				} else
					this.chatWidgetLoading--;
			});
		},
		copyAndToast(string, message, dropdown) {
			let target;
			if(dropdown) {
				target = dropdown.target;
				while(target.nodeName != 'DIV')
					target = target.parentNode;
			}
			this.$util.copyToClipboard(string, target);
			this.$bvToast.toast(message, { title: 'Success', variant: 'success', solid: true });
		},
	},
};
</script>
